var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 19V5H21.5V19H2.5ZM19.5 7H4.5V11H19.5V7ZM4.5 17V13H8.5V17H4.5ZM10.5 13V17H19.5V13H10.5Z",
    fill: "#A3A9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseTemplate);
export default __webpack_public_path__ + "static/media/use-template.a4842de3b79654a48dbfa70ca16cbaab.svg";
export { ForwardRef as ReactComponent };